import api from './axios';
import { Brand } from '../types/brand';

export interface Category {
  id: number;
  name: string;
  nameZh: string;
  nameCn: string;
  description: string;
  descriptionZh: string;
  descriptionCn: string;
  isActive: boolean;
  parentId: number | null;
  createdAt: string;
  imageUrl: string | null;
}

export interface CategoryBrand extends Brand {
  productCount?: number;
}

export const categoriesApi = {
  getCategories: async (): Promise<Category[]> => {
    try {
      const response = await api.get('/api/shop/categories');
      return response.data;
    } catch (error) {
      console.error('Error fetching categories:', error);
      return [];
    }
  },

  getCategoryBrands: async (categoryId: number): Promise<CategoryBrand[]> => {
    try {
      const response = await api.get(`/api/categories/${categoryId}/brands`);
      return response.data;
    } catch (error) {
      console.error('Error fetching category brands:', error);
      return [];
    }
  },
};
